export default __webpack_public_path__ + "static/media/growth-curve.234cdf0f.jpg";